import { useState, useEffect } from "react";
import { getTimingStatistics } from "../../../../server/Statistics/Requests";
import { TimingStatisticsOutput } from "../../../../server/Statistics/OutputsTypes";
import { normalizeTimingData, TimingData } from "../utils/timingUtils";

export const useTimingData = () => {
  const [data, setData] = useState<TimingData>({
    daily: [],
    weekly: [],
    monthly: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getTimingStatistics();

        if (response.status === 200 && response.body) {
          const rawData = response.body as TimingStatisticsOutput;
          console.log("📊 Données brutes reçues:", rawData);

          // Normaliser les données avec la nouvelle fonction
          const normalizedData = normalizeTimingData(rawData);
          console.log("✅ Données normalisées:", normalizedData);

          setData(normalizedData);
        } else {
          console.log("⚠️ Erreur de statut:", response.status);

          // Gestion spécifique de l'erreur 404
          if (response.status === 404) {
            setError("Aucune donnée de temps enregistrée");
          } else {
            throw new Error(`Erreur HTTP: ${response.status}`);
          }
        }
      } catch (err) {
        console.error("❌ Erreur lors de la récupération des données:", err);
        setError(err instanceof Error ? err.message : "Erreur inconnue");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
};
